<template>
  <RefineComponent
    :element="tender"
    :subtitle="subtitle"
    :title="$t('Tenders.CheckTheData')">
    <template #bread>
      <TenderBreadcrumbs
        :check-exit="checkChages"
        :dialog.sync="is_dialog"/>
    </template>
    <template #step>
      <StepNumber/>
    </template>
    <template #next_step>
      <div class="flex flex-wrap flex-direction-column align-self-stretch justify-space-between ">
        <NextStep/>
        <div class="flex align-center gap-5">
          <ImportSpecifyXLS
            v-if="tender"
            :disabled="imported || !positions.length"
            :tender="tender"
            @finishImportLots="imported = false"
            @onSubmitTender="updateTender"
            @startImportLots="imported = true"/>
          <AdditionalFields
            v-if="$can('use', 'availableAdditionalFields')"
            :additional_fields.sync="additional_fields"
            binding-level="LOT"
            @changeOrder="updateAdditionalColumns"
            @update:additional_fields="updateAdditionalColumns"/>
        </div>
      </div>
    </template>
    <template #table>
      <sForm
        ref="specifyTenderForm"
        :disabled="imported"
        :model="{rows: positions}"
        :rules="specifyTenderRules">
        <RowsTable
          :additional_fields="additional_fields"
          :change-field="checkValid"
          class="tender-lots"
          :disabled="imported"
          :headers="headers"
          :positions.sync="positions"
          :tender="tender"
          validate-prop-prefix="rows"/>
      </sForm>
    </template>
    <template #footer>
      <CreateTenderFooter
        key="footer"
        :back="auction && auctionFirstStep ? cancel : null"
        :back_btn="auction && auctionFirstStep ? $t('Common.Cancel') : true"
        :check-chages="checkChages"
        :next="nextStep"
        next_btn
        :publish.sync="is_dialog"
        :validate="checkValid"/>
    </template>
  </RefineComponent>
</template>
<script>
import NextStep from 'components/tenders/NextStep.vue'
import RowsTable from 'components/common/blocks/RowsTable.vue'
import RefineComponent from 'pages/templates/RefineComponent.vue'
import StepNumber from 'components/common/elements/StepNumber.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import CreateTenderFooter from 'components/tenders/CreateTenderFooter.vue'
import AdditionalFields from 'components/additional fields/AdditionalFields.vue'

import ImportSpecifyXLS from 'components/tenders/dialogs/ImportXLS/ImportSpecifyXLS.vue'

import { mapGetters } from 'vuex'
import { tenderMixin ,beforeunloadMixin, modalMixin, additionalFieldsMixin } from 'mixins'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const fields_api = new AdditionalFieldsApi()

export default {
  name: 'specifyTender',
  mixins: [ tenderMixin, modalMixin, beforeunloadMixin,  additionalFieldsMixin],
  data() {
    return {
      currencies: [],
      headers: [],
      addresses: [],
      old: [],
      all_additional_fields: [],
      existing_fields: [],
      additional_fields: [],
      old_additional_fields: [],
      specifyTenderRules: {},
      oldPositions: {},

      imported: false, //Идет импорт данных из Excel

    }
  },
  props: {
    auction: Boolean,
    auctionFirstStep: Boolean,// первый шаг для публикации аукциона
  },
  async created() {
    this.$_setHeaders(true)
    try {
      if (this.tender.tenderId && this.$can('use', 'availableAdditionalFields')) {
        await fields_api.getAdditionalFieldsByEntity({
          entityKey: this.tender.tenderId + '',
        })
          .then(async res => {
            if (res?.length) {
              this.all_additional_fields = res
              await this.$store.dispatch('setAdditionalFieldsTypes')
              let fileds = res
                .filter(field => field.bindingLevel == 'LOT')
                .map(field => ({
                  ...field,
                  bindingCondition: this.$acl.check('tenderAdmin') ? {
                    biddingTypeIds: [],
                    classificationCodes: [],
                  } : field.bindingCondition,
                  type: this.additional_types?.find(type => type.id == field.typeId)
                }))

              this.additional_fields = this.$_.cloneDeep(fileds)
              this.old_additional_fields = this.$_.cloneDeep(fileds)
            }

            await fields_api.getAdditionalFieldsByBindingConditions({
              classificationCode: this.tender?.classificationCode,
              biddingTypeId: this.tender.biddingType?.biddingTypeId,
              bindingLevel: ['TENDER', 'LOT']
            }).then(res => {
              if ( res?.length ) {
                this.existing_fields = res
                  .filter(f => f.active && f.bindingLevel == 'LOT' && !this.additional_fields.some(el => el.id == f.id) )
                  .map(field => ({
                    ...field,
                    bindingCondition: this.$acl.check('tenderAdmin') ? {
                      biddingTypeIds: [],
                      classificationCodes: [],
                    } : [],
                    type: this.additional_types?.find(type => type.id == field.typeId), value: ''
                  }))
              }
            })
            this.updateAdditionalColumns().then((result) => {
              const parseValue = (additionalFields) => {
                Object.values(additionalFields).forEach((additionalField) => {
                  additionalField.value = additionalField.value ? additionalField.value.toString() : null
                })
              }

              if (result?.length) {
                result?.forEach((position) => {
                  parseValue(position?.AdditionalFields)
                  parseValue(position?.additional_fields)
                })
              }
              this.oldPositions = this.$_.cloneDeep(this.positions)
            })
          })
      }
    } catch (_) {
      //ignore
    }
    this.old = this.$_.cloneDeep( this.tender?.lots )
  },
  computed: {
    ...mapGetters({
      tendersSettings: 'getTendersSettings',
      tender: 'getNewTender',
      info: 'getNewTenderInfo'
    }),
    subtitle() {
      if ( this.auction ) {
        return this.$t('Tenders.SpecifyStartingRriceStep')
      }
      let type = this.tender.biddingType?.biddingTypeId
      if ( type == 28 || type == 16 || type == 2 || this.tender.biddingType?.isMultistage) {
        return this.$t('Tenders.SpecifyMonitoringTender')
      }
      if (this.tender.biddingType?.tenderingForPercentage) {

        return this.$t('Tenders.SpecifyTenderForPercentageLots')
      }
      return this.$t('Tenders.SpecifyTenderLots')
    },
    is_dialog: {
      get() {
        return this.auction
      },
      set( newValue ) {
        this.old = this.$_.cloneDeep( this.tender?.lots )
        this.$emit('update:auction', newValue)
      }
    },
    positions: {
      get() {
        return this.$_.cloneDeep(this.tender?.lots)?.sort((a,b) => a.lotNumber - b.lotNumber)
      },
      set(value) {
        this.tender.lots = value
      }
    },
  },
  watch: {
    tender: {
      immediate: true,
      deep: true,
      handler() {
        this.createRules()
      }
    },
    additional_fields: {
      immediate: true,
      deep: true,
      handler() {
        this.createRules()
      }
    },
  },
  methods: {
    updateTender(value) {
      if (!value) { return }

      const bidStepTypes = {
        PERCENT: 0,
        ABSOLUTE: 1,
        CHOOSE: 2
      }
      this.tender.bidStepType = bidStepTypes[value.bidStepType] ?? 0
      value.lots.forEach(lot => {
        let existPositions = this.positions.find(el => el.lotId == lot.lotId)
        if (existPositions) {
          existPositions.startAmount = lot.startAmount
          existPositions.bidStep = lot.bidStep
        }
      })
    },
    /**
     * Если это первый шаг в публикации аукциона, то кнопка назад вызывает выход
     */
    cancel() {
      this.$emit('update:auction', false)
    },
    templateRules(rowNumber) {
      const prefix = `rows[${rowNumber}]`
      const that = this


      const result = {
        [`${prefix}.quantity`]: [{
          type: 'number',
          required: true,
          trigger: 'change',
          min: 0.001,
          transform(value) {
            let valueParse = null
            valueParse = (typeof value === 'number') ? value : (value ? parseFloat(value) : null)
            return valueParse
          },
          message: that.$t('Validate.Required')
        }],
        [`${prefix}.minimalSubmitQuantity`]: [
          {
            type: 'number',
            required: false,
            trigger: 'change',
            validator(rule, value, callback) {
              if (!value) {
                callback()
              }
              const quantity = that.positions[rowNumber].quantity
              if (value > quantity) {
                callback(new Error(that.$tc(that.$tc('Validate.MinimalSubmitQuantityStepNoMore'), quantity)))
              }

              callback()
            }
          }
        ],

        /*[`${prefix}.startAmount`]: [
          {
            type: 'number',
            trigger: 'change',
            validator(rule, value, callback) {
              if (!value && that.positions[rowNumber].bidStep) {
                callback(new Error('Необхідно заповнити при вказаному кроку ставки'))
              }
              callback()
            }
          },
        ],*/
        [`${prefix}.bidStep`]: [
          {
            type: 'number',
            required: false,
            trigger: 'change',
            validator(rule, value, callback) {
              let step_type = !!that.tender?.bidStepType
              if (step_type && value) {
                let min_step = that.tendersSettings.minBidStep,
                  max_step = that.tendersSettings.maxBidStep
                if (!step_type && value > max_step) {
                  callback(new Error(that.$tc('Tenders.BiddingStepNoMore', max_step)))
                }
                if (!step_type && value < min_step) {
                  callback(new Error(that.$tc('Tenders.BiddingStepNoLess', min_step)))
                }
                const halfStartAmount = that.positions[rowNumber].startAmount / 2

                if (halfStartAmount && halfStartAmount < value) {
                  callback(new Error(that.$tc('Tenders.BiddingStepNeedMoreStartAmount', halfStartAmount)))
                }
                let step_error = !!that.positions[rowNumber].startAmount && (value && ( step_type ? that.positions[rowNumber].startAmount / 2 < value : value > max_step || value < min_step ) )
                if (step_error) {
                  callback(new Error(that.$t('Tenders.ErrorInBidStep')))
                }
              }
              callback()
            },
          },
        ],
      }

      this.additional_fields.concat(this.existing_fields).forEach((additional_field) => {
        const required = additional_field.settingValues.some(set => set.settingType == 'REQUIRED' && eval(set.value))
        result[`${prefix}.AdditionalFields.${additional_field.id}`] = [
          {
            type: 'object',
            required: required,
            trigger: 'change',
            fields: {
              value: this.$_getValidationByType(
                additional_field.typeId,
                required
              )
            }
          },
        ]
      })
      return result
    },
    createRules() {
      const headerQuantity = this.headers.find(i => i.value === 'quantity')
      if (headerQuantity) {
        headerQuantity.required = true
        headerQuantity.width = '10%'
      }
      return new Promise((resolve) => {
        let specifyTenderRules = {
          ...this.specifyTenderRules
        }
        this.positions?.forEach((element, index) => {
          specifyTenderRules = {
            ...specifyTenderRules,
            ...this.templateRules(index),
          }
        })
        this.$set(this, 'specifyTenderRules', specifyTenderRules)
        resolve()
      })
    },
    checkChages() {
      const positions = this.$_.cloneDeep(this.positions)
      const parseValue = (additionalFields) => {
        if (additionalFields) {
          Object.values(additionalFields).forEach((additionalField) => {
            additionalField.value = additionalField.value ? additionalField.value.toString() : null
          })
        }
      }
      positions?.forEach((position) => {
        parseValue(position?.AdditionalFields)
        parseValue(position?.additional_fields)
      })

      return !this.$_.isEqual(this.oldPositions, positions) || (this.info?.default?.bidStepType != this.tender?.bidStepType && this.tender?.lots.some(el => el.bidStep))
    },
    async updateAdditionalColumns() {
      this.additional_fields?.forEach((additional_field) => {
        if (additional_field.bindingCondition?.length) {
          let needClear = true
          additional_field?.bindingCondition?.forEach((bindingCondition) => {
            if (bindingCondition.biddingTypeId === this.tender.biddingTypeId && bindingCondition.classificationCode === this.tender.classificationCode) {
              needClear = false
            }
          })
          if (needClear) {
            additional_field.bindingCondition = []
          }
        }
      })
      let fields = this.additional_fields.concat(this.existing_fields)

      const headers = this.$_addAdditionalFieldsToHeaders(this.headers, fields, true)

      this.$set(this, 'headers', headers)

      this.positions?.forEach(lot => {
        this.$set(lot, 'additional_fields', lot.additional_fields || {})
        this.$set(lot, 'AdditionalFields', lot.additional_fields || {})

        fields?.forEach(field => {
          if ( lot.additional_fields[field.id] ) { return }
          let field_value =  field?.value || field.fieldValues?.find(values => values.entityKey == lot.lotId)?.value || '',
            value = this.$_.cloneDeep(field)
          this.$set(value, 'value', field_value)
          this.$set(value, 'order', field.order)
          this.$set(lot.additional_fields, field.id, value)
        })
        this.$_.forEach(this.$_.values(lot.additional_fields), field =>  {
          if ( !fields.some(el => el.id == field.id) ) {
            this.$delete(lot.additional_fields, field.id)
          }
        })
      })
      this.createRules().then(() => {
        //this.checkValid()
        return this.$_.cloneDeep(this.positions)
      })
    },
    checkValid() {
      return new Promise((resolve) => {
        if (!this.$refs.specifyTenderForm) { return }
        this.$refs.specifyTenderForm.validate((valid) => {
          return resolve(valid)
        })
      })
    },
    async nextStep() {
      this.positions = this.positions.map(el => {
        el.description = el.description?.trim() || ''
        return el
      })
      if (this.auction && this.tender.lots.some(lot => lot.bidStep || lot.startAmount) && this.checkChages()) {
        await api.fillAuctionData(this.tender.tenderId, {
          bidStepType: this.tender.bidStepType ? 'ABSOLUTE' : 'PERCENT',
          lots: this.tender.lots?.map(lot => ({
            lotId: lot.lotId,
            startAmount: lot.startAmount,
            bidStep: lot.bidStep,
          }))
        } ).then(res => {
          if ( res ) {
            this.$store.commit('ediTender', {
              bidStepType: this.tender.bidStepType,
              lots: this.$store.getters.getTender.lots.map(lot => {
                let new_lot = this.tender.lots.find(el => el.lotId == lot.lotId)
                return {
                  ...lot,
                  initialAmount: new_lot.startAmount,
                  minimalStepPercent: new_lot.bidStep,
                  bidPriceLimit: new_lot.bidPriceLimit
                }
              })
            })
          }
        })
      }

      let lots = this.$_.cloneDeep(this.positions),
        old_lots = this.$_.cloneDeep(this.old),
        map = lot => lot.additional_fields

      if (this.$can('use', 'availableAdditionalFields') && (!this.$_.isEqual(lots.map(map) ,  old_lots.map(map)) || this.existing_fields.some(f => f.value)) ) {
        let createFieldObject = (existField, lotId) => {
          let fieldValue = existField?.fieldValues?.find(el => el.entityKey == (lotId || this.tender.tenderId) )
          const fieldOrder = this.additional_fields.find(i => i.id === existField.id)?.order
          return {
            valueId: fieldValue?.id || '00000000-0000-0000-0000-000000000000',
            fieldId: existField.id,
            entityKey: (lotId || this.tender.tenderId) + '',
            value: (existField?.value || fieldValue?.value || '') + '',
            order: fieldOrder || existField.order
          }
        }
        let tender_additional = this.all_additional_fields.filter(field => field.bindingLevel == 'TENDER').map(f => createFieldObject(f))
        let lots_additional = []
        let fields = this.additional_fields.concat(this.existing_fields)

        this.$_.forEach(this.positions,
          lot => this.$_.forEach(
            this.$_.values(lot.additional_fields),
            field => {
              if (fields.some(el => el.id == field.id) ) {
                const fieldObject = createFieldObject(field, lot.lotId)
                lots_additional.push(fieldObject)
              }
            })
        )

        if (this.checkChages()) {
          await fields_api.bindAdditionaFiledToEntity({
            entityKey: this.tender.tenderId + '' ,
            fieldValues: tender_additional.concat(lots_additional)
          })
        }
      }
      if (this.auction) {
        const currentStepNum = this.step || this.info.step || 1
        this.$store.commit('setNewTenderInfo', {...this.info, step: currentStepNum + 1 })
      }
    },
  },
  components: {
    NextStep,
    RowsTable,
    StepNumber,
    RefineComponent,
    ImportSpecifyXLS,
    AdditionalFields,
    TenderBreadcrumbs,
    CreateTenderFooter,
  }
}
</script>
<style lang="scss" scoped>
.error-info {
  font-size: 14px;
  color: var(--color-error);
  max-height: 100%;
  overflow: auto;
  background: var(--v-main__light_green-base);
  padding: 0 10px;
  border-radius: 5px;
}
.quantity .v-input__slot{
  min-width: 80px;
}
</style>
<style lang="scss">
#component-layout-refine .tender-lots .v-data-table {
  background: var(--v-main__light_green-base);
  .textarea {
    .v-input__slot {
      padding: 0 !important;
      textarea {
        min-height: 16px;
      }
    }
  }
  td,  .v-data-table-header tr th  {
    &.text-start.pa-0 {
      padding: 0 !important;
    }
  }
}
</style>
